var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AttributeModule',{ref:"attributeForm",attrs:{"show":_vm.attributeModule.show,"data":_vm.attributeModule.data,"shapeWrapData":_vm.attributeModule.shapeWrapData},on:{"close":_vm.handlerModelCancel}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b3c6e7b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ploter/businessShape/index.vue
// module id = null
// module chunks = 